import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Phone } from 'lucide-react';
import { ksbData } from '../../data/ksb';
import PDFModal from '../../components/PDFModal';
import './KSBSubpage.css';

const BombasPage = () => {
  const navigate = useNavigate();
  const [pdfModal, setPdfModal] = useState(null);
  const whatsappNumber = '5493413047536';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=¡Hola!%20Quiero%20consultar%20sobre%20bombas%20KSB`;

  const pageData = ksbData['bombas'];

  return (
    <>
    <div className="ksb-subpage-container" data-testid="ksb-bombas-page">
      {/* Hero Section */}
      <section className="ksb-subpage-hero">
        <div className="ksb-subpage-hero-content">
          <h1 className="ksb-subpage-hero-title">{pageData.title}</h1>
          {pageData.intro.length > 0 && pageData.intro.map((text, idx) => (
            <p key={idx} className="ksb-subpage-hero-description">{text}</p>
          ))}
        </div>
      </section>

      {/* Cards Section */}
      <section className="ksb-subpage-cards-section">
        <div className="container">
          <div className="ksb-subpage-cards-grid">
            {pageData.sections[0].cards.map((card, idx) => (
              <Card
                key={idx}
                className={`ksb-subpage-card${(card.pdfHref || (!card.catalogLinks && card.href)) ? ' ksb-subpage-card--clickable' : ''}`}
                data-testid={`card-${card.title.toLowerCase().replace(/\s+/g, '-').replace(/[/]/g, '-')}`}
                onClick={() => {
                  if (card.pdfHref) setPdfModal({ url: card.pdfHref, title: card.title });
                  else if (card.href) navigate(card.href);
                }}
              >
                <CardContent className="ksb-subpage-card-content">
                  <div className="ksb-subpage-card-image">
                    <img
                      src={card.image}
                      alt={card.title}
                      loading="lazy"
                      className="card-image"
                    />
                  </div>
                  <h3 className="ksb-subpage-card-title">{card.title}</h3>
                  <p className="ksb-subpage-card-description">{card.description}</p>
                  <span className="ksb-subpage-card-arrow">→</span>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="ksb-subpage-cta-section">
        <div className="container">
          <p className="ksb-subpage-cta-text">{pageData.ctaText}</p>
          <Button 
            size="lg" 
            className="ksb-subpage-cta-button"
            onClick={() => window.open(whatsappLink, '_blank')}
            data-testid="bombas-contact-button"
          >
            <Phone className="mr-2" size={20} />
            ¡Contactanos!
          </Button>
        </div>
      </section>
    </div>

    {pdfModal && (
      <PDFModal
        pdfUrl={pdfModal.url}
        title={pdfModal.title}
        onClose={() => setPdfModal(null)}
      />
    )}
    </>
  );
};

export default BombasPage;
